import React, { useState } from 'react';
import { Link, usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import Imgix, { Background } from 'react-imgix';
import List from '../Components/List/List';
import ListItem from '../Components/ListItem';
import Pagination from "../Components/List/Pagination";
import AppHead from "../Shared/AppHead";

const Playlist = ({
                    videos,
                    playlistName,
                    basePath,
                    perPage,
                    currentPage,
                    totalItems
}) => {
  const { imgixURL } = usePage().props;

  const [itemsMeta, _] = useState({
    currentPage: currentPage,
    total: totalItems,
    pageSize: perPage,
  })

  const onPageChange = (pageNumber) => {
    // go to requested page
    window.location.href = `${basePath}?page=${pageNumber}`;
  }

  return (
    <>
      <AppHead title={ playlistName } />

      <Background className='hero min-h-[25vh] mb-4 bg-cover'
                  src={`https://${imgixURL}/cms/homepage/jpm-plus-bg-20220912075650.jpg`}
                  imgixParams={{ auto: 'format', fit: 'crop', crop: 'center', blend: '000', bm: 'normal', balph: '40' }}
                  sizes='100vw'>
        <div className='hero-overlay bg-opacity-60'></div>
        <div className='hero-content text-center'>
          <div className='max-w-md'>
            <h1 className='text-3xl font-bold text-white'>{ playlistName }</h1>
          </div>
        </div>
      </Background>
      <div className='container' data-theme='jpm'>
        <div>
          <List
            elements={videos}
            totalElements={videos.length}
            viewportWidth={200}
            listItem={el => <ListItem
              imageUrl={el.thumbnail_url}
              title={el.title}
              isHorizontalScroll={false}
              sermonId={el.is_episode && el.episode.episode_identifier_string}
              date={el.is_episode ? el.youtube_published_at_diff: el.youtube_published_at}
              link={'/on-demand/watch/' + el.slug}
              itemIsLocked={el.is_locked}
              videoDuration={el.video_duration ?? ''}
            />}
          />

          <Pagination
              onPageChange={onPageChange}
              totalCount={itemsMeta.total}
              currentPage={itemsMeta.currentPage}
              pageSize={itemsMeta.pageSize}
          />
          <div className={`col-12 pt-4 pb-4`}>
            <div className='w-full border-b border-solid border-[#7D7D7D]'></div>
          </div>
        </div>
      </div>
    </>
  );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
Playlist.layout = page => <Layout title='Playlist' children={page} data-theme='jpm' />;

export default Playlist;
